import somar from "./desjejum_especial";
import somardesjejum from "./desjejum1";

const produto_servico = document.querySelector("#produto_servico");
const desjejum = document.querySelector("#desjejum");
const cafe_litro = document.querySelector("#cafe_litro");
const leite_litro = document.querySelector("#leite_litro");
const x_tudo = document.querySelector("#x_tudo");
const h_extra = document.querySelector("#h_extra");
const refri_lata = document.querySelector("#refri_lata");
const refri_2l = document.querySelector("#refri_2l");
const cafe_tarde = document.querySelector("#cafe_tarde");
const servico = document.querySelector("#servico");
const dm_sopa = document.querySelector("#dm_sopa");
const cliente = document.querySelector("#cliente");
const aviso = document.querySelector("#aviso");
const cafe_noite = document.querySelector("#cafe_noite");
const cheff_gourmet = document.querySelector("#cheff_gourmet");
const especial = document.querySelector("#especial");
const desjejum1 = document.querySelector("#desjejum1");
const pao_pre_mus = document.querySelector("#pao_pre_mus");
const lanche_proteico = document.querySelector("#lanche_proteico");

const hideElement = (el) => (el.style.display = "none");
const showElement = (el) => (el.style.display = "");

if (servico) hideElement(servico);

if (desjejum) hideElement(desjejum);

if (cafe_litro) hideElement(cafe_litro);

if (leite_litro) hideElement(leite_litro);

if (x_tudo) hideElement(x_tudo);

if (h_extra) hideElement(h_extra);

if (refri_2l) hideElement(refri_2l);

if (refri_lata) hideElement(refri_lata);

if (cafe_tarde) hideElement(cafe_tarde);

if (dm_sopa) hideElement(dm_sopa);

if (aviso) hideElement(aviso);

if (cafe_noite) hideElement(cafe_noite);

if (cheff_gourmet) hideElement(cheff_gourmet);

if (especial) hideElement(especial);

if (desjejum1) hideElement(desjejum1);

if (pao_pre_mus) hideElement(pao_pre_mus);

if (lanche_proteico) hideElement(lanche_proteico);

if (cliente) {
  cliente.addEventListener("change", (e) => {
    limparCampos();
    if (e.target.value === cliente.value) {
      if (
        (cliente.value == 76 || cliente.value == 9) &&
        (produto_servico.value == 6 || produto_servico.value == 12)
      ) {
        showElement(dm_sopa);
      } else {
        hideElement(dm_sopa);
      }

      if (
        cliente.value == 8 &&
        (produto_servico.value == 6 ||
          produto_servico.value == 12 ||
          produto_servico.value == 17)
      ) {
        showElement(cheff_gourmet);
      } else {
        hideElement(cheff_gourmet);
      }

      if (
        [
          5, 10, 12, 15, 16, 20, 17, 18, 19, 21, 22, 23, 24, 31, 43, 33, 72, 90,
          54, 55, 73, 91, 113, 119, 120, 121, 123,
        ].find((id) => id == cliente.value) != undefined &&
        (document.getElementById("produto_servico").value == 12 ||
          document.getElementById("produto_servico").value == 6 ||
          document.getElementById("produto_servico").value == 17)
      ) {
        showElement(aviso);
      } else {
        hideElement(aviso);
      }
    }
  });
}

if (produto_servico) {
  produto_servico.addEventListener("change", (e) => {
    limparCampos();

    if (e.target.value === produto_servico.value) {
      if (produto_servico.value == 1) {
        showElement(desjejum);
        hideElement(servico);
        showElement(cafe_litro);
        showElement(leite_litro);
        hideElement(x_tudo);
        hideElement(h_extra);
        hideElement(refri_2l);
        hideElement(refri_lata);
        hideElement(cafe_tarde);
        hideElement(cafe_noite);
        hideElement(especial);
        hideElement(desjejum1);
        hideElement(pao_pre_mus);
        hideElement(lanche_proteico);
      } else if (produto_servico.value == 7) {
        hideElement(desjejum);
        hideElement(servico);
        showElement(cafe_litro);
        showElement(leite_litro);
        hideElement(x_tudo);
        hideElement(h_extra);
        hideElement(refri_2l);
        hideElement(refri_lata);
        showElement(cafe_tarde);
        hideElement(cafe_noite);
        hideElement(especial);
        hideElement(desjejum1);
        hideElement(pao_pre_mus);
        hideElement(lanche_proteico);
      } else if (
        produto_servico.value == 2 ||
        produto_servico.value == 8 ||
        produto_servico.value == 13
      ) {
        hideElement(cafe_tarde);
        hideElement(servico);
        showElement(cafe_litro);
        hideElement(leite_litro);
        hideElement(x_tudo);
        hideElement(h_extra);
        hideElement(refri_2l);
        hideElement(refri_lata);
        hideElement(desjejum);
        hideElement(cafe_noite);
        hideElement(especial);
        hideElement(desjejum1);
        hideElement(pao_pre_mus);
        hideElement(lanche_proteico);
      } else if (
        produto_servico.value == 3 ||
        produto_servico.value == 9 ||
        produto_servico.value == 14
      ) {
        hideElement(cafe_tarde);
        hideElement(servico);
        hideElement(cafe_litro);
        showElement(leite_litro);
        hideElement(x_tudo);
        hideElement(h_extra);
        hideElement(refri_2l);
        hideElement(refri_lata);
        hideElement(desjejum);
        hideElement(cafe_noite);
        hideElement(especial);
        hideElement(desjejum1);
        hideElement(pao_pre_mus);
        hideElement(lanche_proteico);
      } else if (
        produto_servico.value == 4 ||
        produto_servico.value == 10 ||
        produto_servico.value == 15
      ) {
        hideElement(cafe_tarde);
        hideElement(servico);
        hideElement(cafe_litro);
        hideElement(leite_litro);
        showElement(x_tudo);
        hideElement(h_extra);
        hideElement(refri_2l);
        showElement(refri_lata);
        hideElement(desjejum);
        hideElement(cafe_noite);
        hideElement(especial);
        hideElement(desjejum1);
        hideElement(pao_pre_mus);
        hideElement(lanche_proteico);
      } else if (
        produto_servico.value == 5 ||
        produto_servico.value == 11 ||
        produto_servico.value == 16
      ) {
        hideElement(cafe_tarde);
        hideElement(servico);
        hideElement(cafe_litro);
        hideElement(leite_litro);
        hideElement(x_tudo);
        showElement(h_extra);
        hideElement(refri_2l);
        hideElement(refri_lata);
        hideElement(desjejum);
        hideElement(cafe_noite);
        hideElement(especial);
        hideElement(desjejum1);
        hideElement(pao_pre_mus);
        hideElement(lanche_proteico);
      } else if (
        produto_servico.value == 6 ||
        produto_servico.value == 12 ||
        produto_servico.value == 17
      ) {
        showElement(servico);
        hideElement(cafe_tarde);
        hideElement(cafe_litro);
        hideElement(leite_litro);
        showElement(x_tudo);
        showElement(h_extra);
        hideElement(refri_2l);
        showElement(refri_lata);
        hideElement(desjejum);
        hideElement(cafe_noite);
        hideElement(especial);
        hideElement(desjejum1);
        hideElement(pao_pre_mus);
        hideElement(lanche_proteico);
      } else if (
        produto_servico.value == 18 ||
        produto_servico.value == 20 ||
        produto_servico.value == 22
      ) {
        hideElement(cafe_tarde);
        hideElement(servico);
        hideElement(cafe_litro);
        hideElement(leite_litro);
        hideElement(x_tudo);
        hideElement(h_extra);
        hideElement(refri_2l);
        showElement(refri_lata);
        hideElement(desjejum);
        hideElement(cafe_noite);
        hideElement(especial);
        hideElement(desjejum1);
        hideElement(pao_pre_mus);
        hideElement(lanche_proteico);
      } else if (
        produto_servico.value == 19 ||
        produto_servico.value == 21 ||
        produto_servico.value == 23
      ) {
        hideElement(cafe_tarde);
        hideElement(servico);
        hideElement(cafe_litro);
        hideElement(leite_litro);
        hideElement(x_tudo);
        hideElement(h_extra);
        showElement(refri_2l);
        hideElement(refri_lata);
        hideElement(desjejum);
        hideElement(cafe_noite);
        hideElement(especial);
        hideElement(desjejum1);
        hideElement(pao_pre_mus);
        hideElement(lanche_proteico);
      } else if (produto_servico.value == 24) {
        showElement(cafe_noite);
        hideElement(cafe_tarde);
        hideElement(servico);
        showElement(cafe_litro);
        showElement(leite_litro);
        hideElement(x_tudo);
        hideElement(h_extra);
        hideElement(refri_2l);
        hideElement(refri_lata);
        hideElement(desjejum);
        hideElement(especial);
        hideElement(desjejum1);
        hideElement(pao_pre_mus);
        hideElement(lanche_proteico);
      } else if (produto_servico.value == 50) {
        showElement(desjejum);
        showElement(especial);
        somar("qtde_desjejum");
        hideElement(servico);
        hideElement(cafe_litro);
        hideElement(leite_litro);
        hideElement(x_tudo);
        hideElement(h_extra);
        hideElement(refri_2l);
        hideElement(refri_lata);
        hideElement(cafe_tarde);
        hideElement(cafe_noite);
        hideElement(desjejum1);
        hideElement(pao_pre_mus);
        hideElement(lanche_proteico);
      } else if (produto_servico.value == 51) {
        showElement(cafe_tarde);
        showElement(especial);
        somar("qtde_cafe_tarde");
        hideElement(servico);
        hideElement(cafe_litro);
        hideElement(leite_litro);
        hideElement(x_tudo);
        hideElement(h_extra);
        hideElement(refri_2l);
        hideElement(refri_lata);
        hideElement(desjejum);
        hideElement(cafe_noite);
        hideElement(desjejum1);
        hideElement(pao_pre_mus);
        hideElement(lanche_proteico);
      } else if (produto_servico.value == 52) {
        showElement(desjejum);
        showElement(desjejum1);
        somardesjejum();
        hideElement(servico);
        hideElement(cafe_litro);
        hideElement(leite_litro);
        hideElement(x_tudo);
        hideElement(h_extra);
        hideElement(refri_2l);
        hideElement(refri_lata);
        hideElement(cafe_tarde);
        hideElement(cafe_noite);
        hideElement(especial);
        hideElement(pao_pre_mus);
        hideElement(lanche_proteico);
      } else if (produto_servico.value == 53 || produto_servico.value == 54) {
        hideElement(desjejum);
        hideElement(desjejum1);
        hideElement(servico);
        hideElement(cafe_litro);
        hideElement(leite_litro);
        hideElement(x_tudo);
        hideElement(h_extra);
        showElement(refri_2l);
        showElement(refri_lata);
        hideElement(cafe_tarde);
        hideElement(cafe_noite);
        hideElement(especial);
        showElement(pao_pre_mus);
        hideElement(lanche_proteico);
      } else if (produto_servico.value == 55 || produto_servico.value == 56) {
        hideElement(desjejum);
        hideElement(desjejum1);
        hideElement(servico);
        hideElement(cafe_litro);
        hideElement(leite_litro);
        hideElement(x_tudo);
        hideElement(h_extra);
        hideElement(refri_2l);
        hideElement(refri_lata);
        hideElement(cafe_tarde);
        hideElement(cafe_noite);
        hideElement(especial);
        hideElement(pao_pre_mus);
        showElement(lanche_proteico);
      }
    }
  });
}

function limparCampos() {
  document.getElementById("qtde_desjejum").value = "";
  document.getElementById("qtde_cafe_litro").value = "";
  document.getElementById("qtde_leite_litro").value = "";
  document.getElementById("qtde_x_tudo").value = "";
  document.getElementById("qtde_h_extra").value = "";
  document.getElementById("qtde_refri_2l").value = "";
  document.getElementById("qtde_refri_lata").value = "";
  document.getElementById("qtde_cafe_tarde").value = "";
  document.getElementById("comensais").value = "";
  document.getElementById("qtde_principal").value = "";
  document.getElementById("qtde_opcao_1").value = "";
  document.getElementById("qtde_omelete_frios").value = "";
  document.getElementById("qtde_omelete_queijo").value = "";
  document.getElementById("qtde_omelete_especial").value = "";
  document.getElementById("qtde_file_frango").value = "";
  document.getElementById("qtde_prato_light").value = "";
  document.getElementById("qtde_veget").value = "";
  document.getElementById("qtde_ovo_frito").value = "";
  document.getElementById("qtde_ovo_cozido").value = "";
  document.getElementById("qtde_dm").value = "";
  document.getElementById("qtde_sopa").value = "";
  document.getElementById("formato").value = "";
  document.getElementById("qtde_cafe_noite").value = "";
  document.getElementById("qtde_pao_c_manteiga").value = "";
  document.getElementById("qtde_pao_c_presunto_mussarela").value = "";
  document.getElementById("qtde_pao").value = "";
  document.getElementById("qtde_minipao").value = "";
}

require("./valores");
require("./edit_desjejum_especial");
require("./edit_desjejum1");
